module.exports = __webpack_public_path__ + "static/media/sliderimg3.71396cdb.png";